import { Component, input, output, ChangeDetectionStrategy, inject } from '@angular/core';
import { IUser } from '@miq/shared-models';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import { NgClass } from '@angular/common';
import { L10nTranslationService } from 'angular-l10n';
/*
 * L2-R6: moved from `src/app/shared/components/pinned-contact-card/pinned-contact-card.component.ts`
 * (share-report is its only consumer, in the reports remote). The old host path is a re-export shim.
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'miq-pinned-contact-card',
  templateUrl: './pinned-contact-card.component.html',
  styleUrl: './pinned-contact-card.component.scss',
  imports: [MatCheckbox, MatTooltip, NgClass],
})
export class PinnedContactCardComponent {
  private readonly translationService = inject(L10nTranslationService);
  user = input<IUser>();
  showPinIcon = input(true);
  pinToggled = output<{ user: IUser; isPinned: boolean }>();
  change = output<{ checked: boolean; user: IUser }>();
  public color: string;
  public isPinned: boolean = true;
  get unpinContactTooltip(): string {
    return this.translationService.translate('reports.unpinContact');
  }
  onPinClick(event: MouseEvent, isPinned: boolean) {
    event.stopPropagation();
    this.pinToggled.emit({ user: this.user(), isPinned: !isPinned });
  }
  onClick(): void {
    this.change.emit({ checked: !this.user().selected, user: this.user() });
  }
}
